<template>
  <div class="dynamic-form-wrapper">
    <div class="detail-info">
    <template v-if="viewType == 'dynamicFormDetail'">
      <el-tabs type="card" class="diagram-content_tab" v-model="activeTab">
        <el-tab-pane
          label="当前流程"
          name="current"
          class="diagram-content_current"
          v-if="detailData"
        >
          <dynamic-form-detail
            :value="detailData.content"
            :status="detailData.status"
            @showQrcode="_showQrcode"
          ></dynamic-form-detail>
          <el-divider class="line-dividing"><span>流程图</span></el-divider>
          <detail-flow
            v-if="detailData && detailData.activityModel"
            :flows="[detailData.activityModel.activitiNodeDetails]"
            :data-status="detailData.status"
          ></detail-flow>
        </el-tab-pane>
        <el-tab-pane
          label="历史记录"
          v-if="showHistory"
          name="history"
          class="diagram-content_history"
        >
          <template v-if="historyRecord && historyRecord.length">
            <div
              class="record-item"
              v-for="(record, index) of historyRecord"
              :key="index"
            >
              <dynamic-form-detail
                :value="record.content"
                :status="record.status"
              ></dynamic-form-detail>
              <el-divider class="line-dividing"><span>流程图</span></el-divider>
              <detail-flow
                :flows="[record.activityModel.activitiNodeDetails]"
                :data-status="record.status"
              ></detail-flow>
            </div>
          </template>
          <template v-else>
            <div class="no-record-data">暂无数据</div>
          </template>
        </el-tab-pane>
      </el-tabs>
    </template>
    <template v-else-if="viewType == 'dynamicFormEdit'">
      <dynamic-form-with-flows
        v-model="formData"
        @update="() => (this._hasFormDataChanged = true)"
        ref="form"
      ></dynamic-form-with-flows>
    </template>
    </div>
    <div class="occupy-ele"></div>
    <div class="operations">
      <el-button size="medium" @click="back">返回</el-button>
      <el-button type="primary" size="medium" @click="showQr" v-if="isShowQrcode&&$reconava.isSelf_phone(detailData.createBySysUserName.mobile)">查看二维码</el-button>
      <template v-if="taskId">
        <el-button
          size="medium"
          @click="addApproval"
          v-if="detailData && detailData.activityModel.isAddNode"
          >加签</el-button
        >
        <el-button size="medium" type="danger" @click="showConfirm('reject')"
          >驳回</el-button
        >
        <el-button size="medium" type="primary" @click="showConfirm('pass')"
          >通过</el-button
        >
      </template>
      <template v-if="viewType == 'dynamicFormEdit'">
        <el-button size="medium" type="primary" @click="submit">提交</el-button>
      </template>
    </div>

    <el-dialog :visible.sync="addApprovalVisible" title="选择加签人">
      <user-cascader v-model="addApprovalUser"></user-cascader>
      <template v-slot:footer>
        <el-button @click="addApprovalVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmAddApprovalVisible"
          >确 定</el-button
        >
      </template>
    </el-dialog>

    <el-dialog :visible.sync="visibleQrDioalog" title="二维码" width="460px">
      <div class="code-info">
        <div class="info_self">
          <img :src="qrcodeInfo.qrUrl" :class="{'blur':qrcodeInfo.check||!qrcodeInfo.isValid}">
        </div>
        <div class="info_time">
          <div class="row">
            <span >开始时间：</span>
            <span >{{qrcodeInfo.startTime}}</span>
          </div>
          <div class="row">
            <span :span="4">结束时间：</span>
            <span :span="20">{{qrcodeInfo.endTime}}</span>
          </div>
          <div class="row valid">
            {{!qrcodeInfo.isValid?'不在有效期范围内，不可使用':qrcodeInfo.check?'已核验':''}}
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="审核" :visible.sync="dialogVisible" width="600px">
      <div class="examine-diablog">
        <div class="examine-item">
          <div class="title">
            <span class="required" v-if="detailData && detailData.content.advanced.approveOpinion[type].required">*</span>
            <span>{{ type === 'pass' ? '审核意见' : '理由' }}</span>
          </div>
          <div class="content">
            <el-input
              rows="3"
              type="textarea"
              :placeholder="detailData ? detailData.content.advanced.approveOpinion[type].msg : ''"
              v-model="reason">
            </el-input>
          </div>
        </div>
        <div class="examine-item">
          <div class="title">
            <span>附件</span>
          </div>
          <div class="content">
            <div style="display: flex;flex-wrap: wrap;align-items: center;">
              <el-upload :style="{ pointerEvents: files.length >= 10 ? 'none' : '' }" ref="upload" class="upload-demo" action="/business/upload" :show-file-list="false" :http-request="uploadFile" :before-upload="beforeUpload" :limit="limitFileNum" :on-exceed="overFile" :multiple="true">
                <i class="el-icon-plus"></i>
              </el-upload>
              <div class="files-item" v-for="(item, index) in files" :key="index">
                <div class="file-img">
                  <img :src="item.url" alt="" v-if="['.png','.jpg','.jpeg','gif','GIF','.PNG','.JPG','.JPEG'].includes(item.url.slice(item.url.lastIndexOf('.')))" @click="handlePreviewClick(files)">
                  <div @click="showViedo(item)" style="width: 100%;height: 100%;margin-left: 2px;margin-top: 1px;background: #bbb8b8;display: flex;align-items: center;justify-content: center;" v-else-if="['.mp4','.wmv','.m4v','.avi','.ogg','.flv','.rmvb'].includes(item.url.slice(item.url.lastIndexOf('.')))">
                  <img style="margin:0;width: 40px;height: 40px;" src="https://reconova-test.oss-cn-zhangjiakou.aliyuncs.com/AIOS/miniprogram/pic/video.png">
                </div>
                  <img :src="getDefaultImg(item.name || item.url)" alt="" @click="getFileImg(item)" v-else>
                  <div :title="item.name">{{ item.name }}</div>
                </div>
                <div @click="removeFile(index)" class="delete">-</div>
              </div>
              <div  class="wordfile" v-if="viedoUrl" @click="closeViedo">
                <div @click.stop="closeViedo" style="position:absolute;top: 6%;right: 7%;font-size: 40px;cursor: pointer;"><i class="el-icon-error"></i></div>
                <div style="width:80%;height:80%;margin-left: 10%;margin-top: 6%;background: #fff;">
                  <video width="100%" height="100%" controls autoplay>
                    <source :src="viedoUrl" type="video/ogg">
                    <source :src="viedoUrl" type="video/mp4">
                    <source :src="viedoUrl" type="video/webm">
                    <object data="movie.mp4" width="100%" height="100%">
                      <embed width="100%" height="100%" :src="viedoUrl">
                    </object>
                  </video>
                </div>
              </div>
              <div class="wordfile" v-if="fileUrl" @click="closeIframe">
                <div @click.stop="closeIframe"
                  style="position:absolute;top: 2%;right: 7%;font-size: 40px;cursor: pointer;"><i
                    class="el-icon-error"></i></div>
                <iframe :src="fileUrl" width='80%' height='90%' frameborder='0'></iframe>
              </div>
            </div>
            <div style="color:#AAAAAA;font-size:14px;margin-top: 10px;">单个文件最大100MB, 最多上传10个文件</div>
          </div>
        </div>
        <div class="footer-btn">
          <el-button @click="handleCancelClick">取消</el-button>
          <el-button type="primary" @click="handleConfirmClick">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DynamicFormDetail from "@/components/dynamicForm/detail.vue";
import dynamicFormWithFlows from "@/businessComponents/dynamicFormWithFlows.vue";
import DetailFlow from "@/components/detail-flow";
import UserCascader from "@/components/UserCascader.vue";
import {formatTime} from "../../../businessModule/dynamicForm/utils/utils";
import uploadCommon from "@/utils/upload";
import { uploadFile } from "@/services/sysapi";
import {Loading} from "element-ui";
import {isIE} from "@/utils/utils";

export default {
  name: "DynamicFormWrapper",
  components: {
    DynamicFormDetail,
    dynamicFormWithFlows,
    DetailFlow,
    UserCascader,
  },
  props: {
    viewType: [String],
    id: [Number, String],
    taskId: [Number, String],
    showHistory: Boolean,
    onBack: Function,
  },
  data() {
    return {
    type: 'pass',
    viedoUrl:'',
    accept: '.png,.jpg,.jpeg,gif,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.dwg,.zip,.rar,.cad,.mp4',
    reason: '',
    dialogVisible: false,
    uploadFileNum:0,
    loadingOption: {
        lock:true,
        text:'文件上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      },
      files: [],
      fileUrl: '',
      detailData: null,
      formData: null,
      activeTab: "current",
      text: "",
      historyRecord: [],
      _hasFormDataChanged: false,
      radio: "",
      addApprovalVisible: false,
      addApprovalUser: [],
      isShowQrcode:false,
      visibleQrDioalog:false,
      qrcodeInfo:{},
    };
  },
  computed:{
    limitFileNum(){
        return 10-this.files.length
      }
    },
  created() {
    this.getDetail();
  },
  methods: {
    handleConfirmClick() {
      const { required, msg } = this.detailData.content.advanced.approveOpinion[this.type];
      if (required && !this.reason) {
        this.$message.warning(msg)
        return
      }
      let params = {
        id: this.id,
        reason: this.reason,
        taskId: this.taskId,
        typeId: 9,
      };
      if (this.files.length) {
        params.remark = JSON.stringify(this.files)
      }
      let fun = this.type == 'pass' ? 'passMyAppply' : 'rejectMyAppply'
      this.$api.checkapi[fun](params).then(res => {
        if (res.code === 200) {
          this.$message.success(res.msg)
          this.dialogVisible = false
          this.back()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleCancelClick() {
      this.dialogVisible = false
    },
    closeViedo(){
      this.viedoUrl = ''
    },
    showViedo(item){
      this.viedoUrl = item.url
    },
    handlePreviewClick(files) {
      if (files && files.length) {
        let images =  files.filter(item => ['.png','.jpg','.jpeg','gif','GIF','.PNG','.JPG','.JPEG'].includes(item.url.slice(item.url.lastIndexOf('.')))).map(item => item.url)
        this.$viewerApi({
          images
        })
      }
    },
    closeIframe(){
      this.fileUrl = ''
    },
    removeFile(index){
      this.files.splice(index,1)
    },
    getFileImg(item){
      const fileType = item.url.substr(item.url.lastIndexOf(".")+1)
      if(['pdf'].includes(fileType)){
        this.fileUrl = item.url
      } else if(['doc','docx','xls','xlsx','ppt','pptx'].includes(fileType)){
        this.fileUrl = "https://view.officeapps.live.com/op/view.aspx?src="+encodeURIComponent(item.url)
      } else {
        this.$message.warning("暂不支持预览该类型的文件！")
      }
      this.fileName = item.name
    },
    getDefaultImg(fileName){
        var orign = 'https://reconova-test.oss-cn-zhangjiakou.aliyuncs.com/AIOS/miniprogram/pic/'
        if (fileName) {
          const splitIndex = fileName.lastIndexOf('.');
          const str = fileName.slice(splitIndex-1)
          if(str.indexOf('.pdf')!=-1){
            return orign + 'pdf1.png'
          }else if(str.indexOf('.doc')!=-1 || str.indexOf('.docx')!=-1){
            return orign + 'word.png'
          }else if(str.indexOf('.xls')!=-1 || str.indexOf('.xlsx')!=-1){
            return orign + 'excel.png'
          }else if(str.indexOf('.ppt')!=-1 || str.indexOf('.pptx')!=-1){
            return orign + 'file_ppt.png'
          }else if(str.indexOf('.zip')!=-1){
            return orign + 'zip.png'
          }else if(str.indexOf('.rar')!=-1){
            return orign + 'rar.png'
          }else{
            return orign + 'file-cion.png'
          }
        } else {
          return orign + 'file-cion.png'
        }
      },
      overFile(files,fileList){
        if(files.length<=(10-this.files.length)){
          return true
        }else{
          this.$message.warning(`最多可上传10个附件,当前最多可选择 ${10-this.files.length} 个附件`);
          this.$refs.upload.clearFiles()
          return false
        }
      },
    beforeUpload(file) {
        if(this.files.length<10){
          file.size > 100 * 1024 * 1024&&this.$message.warning(`文件不能超过${100}M`)
          return !(file.size > 100 * 1024 * 1024)
        }else{
          this.$message.error("最多上传10个附件");
          return false;
        }

      },
    async uploadFile(data) {
        const file = data.file;
        let form = new FormData;
        const fileType = file.type.split('/')[0]
        const type = file.type.split('/')[1]
        let ie = isIE();
        if(['png', 'jpg','jpeg'].includes(type)&&!ie){
          const img = await uploadCommon.readImg(file);
          const blob = await uploadCommon.compressImg(img,500, 500,file.type);
          form.append("file", new window.File([blob], file.name, {type: file.type}));
        }else{
          form.append("file",file)
        }
        let loading = Loading.service(this.loadingOption);
        this.uploadFileNum++;
        uploadFile(form,'notice').then(res => {
          this.uploadFileNum--;
          if(this.uploadFileNum==0){
            loading.close();
          }
            this.files.push({
              name: file.name,
              url: res.data,
              size: file.size,
            })
          this.$refs.upload.clearFiles()
        }).catch(() => {
          loading.close();
        })
      },
    getDescription(list) {
      let description = ''
      for(let i = 0; i < list.length; i++) {
        if (list[i].subType === 'shop' && list[i].value) {
          if (Array.isArray(list[i].value)) {
            description = list[i].value[0].value
          } else {
            description = list[i].value.value
          }
          return description
        }
        if (list[i].type === 'subfield') {
           if (this.getDescription(list[i].children)) {
            return this.getDescription(list[i].children)
           }
        }
      }
    },
    submit() {
      // 提交
      if (!this._hasFormDataChanged) {
        return this.$message.error("表单内容未修改，请修改后提交");
      }
      this.$refs.form.validate().then(() => {
        const flow = this.formData.bpm[this.$refs.form.bpmPriorityIndex];
        let params = {
          id: this.id,
          content: this.formData,
          activityKey: flow.activitiKey,
          activityNodeDetails: flow.nodeInfo,
          basicId: this.formData.basic.id,
        }
        let description = this.getDescription(this.formData.form.formSetting)
        params.content.description = description || ''
        this.$api.dynamicForm
          .updateAndActivate({...params})
          .then(({ code, msg }) => {
            if (code == 200) {
              this.$message.success(msg);
              this.back();
            }
          });
      });
    },
    back() {
      if (this.onBack) {
        this.onBack();
      } else {
        this.$emit("changeType");
      }
    },
    addApproval() {
      if(!this.detailData.content.advanced.allowAddType||this.detailData.content.advanced.allowAddType==" ") return ;
      // 加签
      this.radio = "";
      const messageText = [
        { label: "同一节点（会签）", value: "0" },
        { label: "上一节点（单人审批生效）", value: "1" },
      ]
          .filter(({ value }) =>
              this.detailData.content.advanced.allowAddType.includes(value)
          )
          .filter(({value})=>
              this.detailData.activityModel.userIds.length<=1||value!="1"
          )
      if(!(messageText&&messageText.length)){
        return this.$message.warning('不符合加签条件')
      }
      this.$msgbox({
        title: "加签",
        message: (
          <div>
            {
              messageText.map(({ label, value }) => (
                <label style="display: flex; align-items: center;">
                  <input
                    type="radio"
                    name="addApproval"
                    style="margin-right: 8px;"
                    value={value}
                    onChange={(e) => {
                      this.radio = e.target.value;
                    }}
                    checked={this.radio == value}
                  ></input>
                  {label}
                </label>
              ))}
          </div>
        ),
        showCancelButton: true,
      })
        .then(() => {
          this.addApprovalVisible = true;
        })
        .catch(() => {
          console.log("close");
        });
    },
    confirmAddApprovalVisible() {
      if (!this.addApprovalUser) {
        return this.$message.error("请选择加签人");
      }
      this.$api.dynamicForm
        .addAssignee({
          assignee: this.addApprovalUser,
          isBefore: [false, true][this.radio],
          reason: "",
          taskId: this.taskId,
          id:this.id
        })
        .then(({ code, data, msg }) => {
          if (code == 200) {
            this.$message.success(msg);
            this.addApprovalVisible = false;
            this.back();
          } else {
            this.$message.error(msg);
          }
        });
    },
    showConfirm(type) {
      this.type = type
      this.viedoUrl = ''
      this.reason = ''
      this.files = []
      this.fileUrl = ''
      this.dialogVisible = true
    },
    async getDetail() {
      const { code, data } = await (this.taskId
        ? this.$api.dynamicForm.getWaitDetail(this.taskId)
        : this.$api.dynamicForm.getDetail(this.id));
      if (code == 200) {
        const { content, hasHistory, basicId } = data;
        if (this.viewType == "dynamicFormEdit") {
          // TODO 当编辑的时候，需要校验这个表单是不是最新的，也就是说必须查一次最新的表单
          const { data: formTemplate } =
            await this.$api.dynamicForm.externalForm(basicId);
          const {
              basic: { id:formTemplateId },
            } = formTemplate,
            {
              basic: { id: detailFormId },
            } = content;
          if (formTemplateId != detailFormId) {
            this.$message.warning('您发起的流程表单被修改，之前数据被清空！')
            formTemplate.form.formSetting = Object.values(
              formTemplate.form.formSetting
            );
            this.formData = formTemplate;
          } else {
            content.form.formSetting = Object.values(content.form.formSetting);
            this.formData = content;
          }
        } else {
          this.detailData = data;
          hasHistory && this.getHistory();
        }
      }
    },
    getHistory() {
      const page = {
        pageNum: 1,
        pageSize: 10,
      };
      const getHistory = () => {
        this.$api.dynamicForm
          .getHistory({
            id: this.id,
            ...page,
          })
          .then(({ code, data }) => {
            if (code == 200) {
              const { list, total } = data;
              this.historyRecord = list;
              if (page.pageNum * page.pageSize < total) {
                page.pageNum++;
                getHistory();
              }
            }
            if (code == 450) {
              // 该流程暂无历史
            }
          });
      };
      getHistory();
    },

    _showQrcode(detail){
      this.isShowQrcode =  detail.wx_show;
      this.qrcodeInfo.startTime = formatTime(detail.value[0],'Y-M-D h:m');
      this.qrcodeInfo.endTime = formatTime(detail.value[1],'Y-M-D h:m');
    },

    getQr(id){
      this.$api.dynamicForm.qrcodeDetail(id).then(({data,code}) => {
        if(code==200&&data.qrUrl){
          this.visibleQrDioalog = true;
          this.qrcodeInfo = Object.assign(this.qrcodeInfo,data)
        }else{
          this.$message.error('二维码获取异常')
        }
      })
    },

    showQr(){
      //  获取二维码
      this.getQr(this.detailData.id)
    }
  },
};
</script>

<style lang="scss" scoped>
  ::v-deep .el-upload{
    display: block;
  }
.dynamic-form-wrapper {

  .detail-info{
    background-color: white;
    padding: 16px;
  }
  .operations {
    width: calc(100% - 204px);
    display: flex;
    justify-content: center;
    position: fixed;
    bottom: 0;
    left: 204px;
    right: 0;
    background-color: white;
    padding: 12px;
    border-top: 1px solid #e3e3e3;
  }
}
</style>
<style lang="scss" scoped>
.examine-diablog {
  padding: 10px;
    .examine-item {
    width: 100%;
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;
    .title {
      width: 80px;
      text-align: right;
      padding: 10px;
      margin-right: 10px;
      .required {
        color: red;
      }
    }
    .content {
      flex: 1;
    }
  }
  .upload-demo{
    width: 70px;
    height: 70px;
    line-height: 70px;
    text-align: center;
    background: #F2F2F2;
  }
  .wordfile{
    position: fixed;
    left: 0;
    right:0;
    top:0;
    bottom: 0;
    z-index:99;
    background-color: rgba(0, 0, 0, 0.2);
    iframe{
      margin-left: 10%;
      margin-top: 3%;
    }
  }
  .files-item{
    margin-left: 10px;
    margin-top: 5px;
    position: relative;
  }
  .file-img{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .file-img img{
    width: 45px;
    height: 45px;
  }
  .file-img div{
    max-width: 73px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .delete{
    position: absolute;
    color: #fff;
    background: red;
    width: 15px;
    height: 15px;
    text-align: center;
    line-height: 15px;
    border-radius: 50%;
    right: -6px;
    top: -4px;
    cursor: pointer;
  }
  .footer-btn {
    text-align: right;
  }
}

.msgbox {
  display: flex;
  .label {
    margin-top: 8px;
    margin-right: 8px;
    display: flex;
    .required {
      color: red;
    }
    span {
      flex-shrink: 0;
      margin-right: 8px;
    }
  }
  .input {
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    padding: 8px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
    &:focus {
      border-color: #409eff;
      outline: 0;
    }
  }
}
.code-info{
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 410px;
  .info_self{
    .blur{
      filter:blur(5px)
    }
  }
  .info_time{
    height: 32px;
    line-height: 32px;
    text-align: center;
    .valid{
      text-align: center;
      margin: 10px 0;
      font-size: 18px;
    }
  }
}
</style>